<section style="padding: 15px 0">
  <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
    <mat-card>
      <mat-card-title>
        Your Subscription
      </mat-card-title>
      <div mat-card-content *ngIf="!player.subscription_id">
        <div class="billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Your Plan
          </div>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <div>Free</div>
          </div>
        </div>
        <div>
          <a>
            You are on the free plan, with this plan you can enter your scores and play some wagering game on the app.  
            However you will not be able to keep a USGA Handiap Index or keep track of your stats.  Look at your upgrade options bellow.
          </a>
        </div>
        <div class="billing-padding" fxLayout="row" fxLayoutAlign="end center" *ngIf="usga_club_id>0">
          <button mat-raised-button color="accent" (click)="showUpgradeOptions = !showUpgradeOptions">UPGRADE</button>
        </div>
        <div class="billing-padding" fxLayout="row" fxLayoutAlign="end center" *ngIf="usga_club_id == 0">
          <button mat-raised-button class="orange-button" (click)="findAClub()">FIND A CLUB</button>
        </div>
      </div>
      <div mat-card-content *ngIf="player.subscription_id && current_plan" fxLayout="column">
        <div class="billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div *ngIf="group">
            {{current_plan.nickname}}
            - {{group.group_name}}
            <br/>
            <span *ngIf="product" style="font-style: italic;font-size:smaller">{{product.metadata.long_description}}</span>
          </div>
          <div style="white-space: nowrap">
            {{current_plan.amount/100 | currency}} / {{current_plan.interval}}
          </div>
        </div>
        <div class="billing-padding" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
          <button mat-raised-button color="primary" (click)="manageRounds()">
              Manage Rounds
          </button>
          <button *ngIf="!subscription.cancel_at_period_end" mat-raised-button color="warn" (click)="cancelSubscription()">
            <div *ngIf="!cancelling">CANCEL</div>
            <div *ngIf="cancelling">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </button>
          <button *ngIf="subscription.cancel_at_period_end" mat-raised-button color="accent" (click)="reactivateSubscription()">
            <div *ngIf="!reactivating">RE-ACTIVATE</div>
            <div *ngIf="reactivating">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </button>
        </div>
      </div>
    </mat-card>
    <mat-card *ngIf="error">
      <div style="color:red">{{error}}
      </div>
      <button mat-button (click)="goToProfile()">Profile</button>
    </mat-card>
    <mat-card *ngIf="showUpgradeOptions">
      <mat-card-title *ngIf="group">
        Upgrade Options <br/>
        Activate posting to USGA Club >>> <span style="font-size: larger;">{{group.group_name}}</span> <<<
      </mat-card-title>
      <mat-card-subtitle>
        Upgrading your membership will allow you to post your scores to the World Handicap System through this club using Golf GamesKeeper.
        Select an option below and upgrade your plan to start taking advantage of GGK Handicap+.
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="product">
        {{product.metadata.long_description}}
      </mat-card-subtitle>
      <div mat-card-content>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center"
          *ngFor="let plan of availablePlans">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div fxFlex="400px">
              {{plan.nickname}} <span *ngIf="plan.trial_period_days">({{plan.trial_period_days}} days trial)</span>
            </div>
            <div>
              {{plan.amount/100 | currency}} / {{plan.interval}}
            </div>
          </div>
          <div>
            <button mat-raised-button color="accent" (click)="selectPlan(plan)">
              <div *ngIf="!plan.saving">SELECT</div>
              <div *ngIf="plan.saving">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </mat-card>
    <mat-card *ngIf="current_plan">
      <mat-card-title>
        Billing Details
      </mat-card-title>
      <div mat-card-content fxLayout="column">
        <div *ngIf="!player.subscription_id">
          <h5>No credit card on file, upgrade to a paying plan first.</h5>
        </div>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Status
          </div>
          <div *ngIf="subscription.cancel_at_period_end">
            Cancelled
          </div>
          <div *ngIf="!subscription.cancel_at_period_end">
            Active
          </div>
        </div>

        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Last Transaction
          </div>
          <div>
            {{subscription.current_period_start*1000 | date : "medium"}}
          </div>
        </div>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div *ngIf="subscription.cancel_at_period_end">
            Valid Until
          </div>
          <div *ngIf="!subscription.cancel_at_period_end">
            Next Invoice
          </div>
          <div>
            {{subscription.current_period_end*1000 | date : "mediumDate"}}
          </div>
        </div>
      </div>
    </mat-card>
    <mat-card *ngIf="current_plan">
      <mat-card-title>
        Payment Details
      </mat-card-title>
      <div mat-card-content fxLayout="column" *ngIf='paymentMethod'>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Name
          </div>
          <div>
            {{player.first}} {{player.last}}
          </div>
        </div>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Credit Card
          </div>
          <div>
            {{paymentMethod.card.brand}} ({{paymentMethod.card.last4}})
          </div>
        </div>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            Exp. Date
          </div>
          <div>
            {{paymentMethod.card.exp_month}} / {{paymentMethod.card.exp_year}}
          </div>
        </div>
      </div>
      <div class="billing-padding" fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button color="accent" (click)="updateCard()">
          <div *ngIf="!updatingCard">UPDATE CARD</div>
          <div *ngIf="updatingCard">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
        </button>
      </div>
    </mat-card>
    <mat-card *ngIf="invoices">
      <mat-card-title>
        Invoices
      </mat-card-title>
      <div mat-card-content>
        <div class="billing-row billing-padding" fxLayout="row" fxLayoutAlign="space-between center"
          *ngFor="let invoice of invoices">
          <div>
            {{invoice.amount_due/100 | currency}}
          </div>
          <div class="badge" style="padding:3px!important;text-transform: capitalize;background-color: indianred; color: white;">
            {{invoice.status}}
          </div>
          <div>
            {{invoice.created*1000 | date : "mediumDate"}}
          </div>
          <div fxFlex="nogrow">
            <button mat-icon-button (click)='viewInvoice(invoice)'>
              <mat-icon matTooltip='View'>
                open_in_new
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</section>